/**
 * 错误上报配置（对齐移动端）
 * 接口：POST /system/error/report
 * 开关：POST /system/basic/conf → data.is_enabled（1 开 / 0 关）
 */
export default {
  /** 仅当 conf 尚无 is_enabled 时回退；正式以后端 is_enabled 为准 */
  enabled: false,
  reportUrl: '/system/error/report',
  storageKey: 'error_reports',
  enableStorage: true,
  enableConsole: false,
  batchInterval: 5000,
  maxBatchSize: 10,
  dedupeTime: 300000,
}
